// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const TopAnchorButtonArrowUp: React.FC<{
    size?: number;
    color1?: string;
    color2?: string;
    color3?: string;
    color4?: string;
    className?: string;
}> = ({ size = 48, color2 = "#fff", color3 = "#ccc", className }) => (
    <svg
        className={className}
        focusable="false"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 48 48"
        width={size}
        height={size}
    >
        <defs>
            <filter id="b" width="155.6%" height="155.6%" x="-27.8%" y="-22.2%" filterUnits="objectBoundingBox">
                <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="3" />
                <feColorMatrix
                    in="shadowBlurOuter1"
                    values="0 0 0 0 0.933333333 0 0 0 0 0.933333333 0 0 0 0 0.933333333 0 0 0 1 0"
                />
            </filter>
            <circle id="a" cx="18" cy="18" r="18" />
        </defs>
        <g fill="none" fillRule="evenodd" transform="rotate(-90 23 19)">
            <use xlinkHref="#a" fill="currentColor" filter="url(#b)" />
            <use xlinkHref="#a" fill={color2} />
            <path
                fill={color3}
                fillRule="nonzero"
                d="M18 0c9.941 0 18 8.059 18 18s-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0m0 .5C8.335.5.5 8.335.5 18S8.335 35.5 18 35.5 35.5 27.665 35.5 18 27.665.5 18 .5"
            />
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M22.758 18.578a.81.81 0 0 0 0-1.156L14.42 9.238a.85.85 0 0 0-1.178 0 .81.81 0 0 0 0 1.156L20.992 18l-7.75 7.606a.81.81 0 0 0 0 1.156.85.85 0 0 0 1.178 0z"
            />
        </g>
    </svg>
);

export default React.memo(TopAnchorButtonArrowUp);
